import React, { useState, useEffect, useRef } from 'react'
import './styles.scss'

interface IpropType {
  fieldsNumber?: number
  value?: number[] | string
  onChange: any
}

export default function SingleDigitsInput({ fieldsNumber = 4, value, onChange }: IpropType) {
  const updateInput = (value, index) => {
    if (value !== undefined) {
      const upatedInputs = [...inputFields]

      if (value.length > 1) {
        const fillMultipleInputs = generateFillMultipleInputs()
        const resultado = fillMultipleInputs(value)

        setInputFields(resultado)
        return
      }

      upatedInputs[index] = value
      setInputFields(upatedInputs)
      changeFocus(index)
    }
  }

  useEffect(() => {
    updateInput(value, 0)
    // eslint-disable-next-line
  }, [value])

  const ref = useRef(null);

  const [inputFields, setInputFields] = useState(Array(fieldsNumber).fill(''))


  function generateFillMultipleInputs() {
    const updatedInput = [...inputFields]

    function fillMultipleInputs(value) {
      for (let i = 0; i < updatedInput.length; i++) {
        if (value[i] === undefined) {
          break
        }

        updatedInput[i] = value[i]
      }
      return updatedInput
    }

    return fillMultipleInputs
  }

  const changeFocus = (index) => {
    if (index + 1 === inputFields.length) {
      const input = document.getElementById(`digit-${index}`)
      if (input) input.blur()
      return
    }

    const input = document.getElementById(`digit-${index + 1}`)
    if (input) input.focus()
  }


  const handleOnchange = (e, i) => {
    updateInput(e.target.value, i)
    const currentInputFields= [...inputFields]
    currentInputFields[i] = e.target.value;

    onChange(currentInputFields);
  }

  return (
    <div 
    ref={ref}
    className='single-digits-input-container'>
      {inputFields.map((b, i) => (
        <input
          key={i}
          value={b}
          onChange={e => handleOnchange(e,i)}
          className='digit'
          id={`digit-${i}`}
        />
      ))}
    </div>
  )
}
